function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback, useEffect, useState } from 'react';
import { buildService } from '../service';
import serviceMethods from '../service_methods';
const api = buildService('/claims/{id}/subsidiary_claims', {
  only: ['all', 'update']
});
const claimGroupBasedApi = buildService('/claim_groups/{id}/subsidiary_claims', {
  only: ['all']
});
const subsidiaryClaimService = {
  useFetchAllByClaimGroup: _ref => {
    let {
      setLoading,
      claimGroupId
    } = _ref;
    const [subsidiaryClaims, setSubsidiaryClaims, fetchSubsidiaryClaims] = serviceMethods.useFetch({
      callback: useCallback(async () => {
        if (!claimGroupId) {
          return [];
        }
        return (await claimGroupBasedApi.all(claimGroupId)).subsidiary_claims;
      }, [claimGroupId]),
      setLoading
    });
    return [subsidiaryClaims, setSubsidiaryClaims, fetchSubsidiaryClaims];
  },
  useFetchAll: _ref2 => {
    let {
      setLoading,
      claimId
    } = _ref2;
    const [subsidiaryClaims, setSubsidiaryClaims, fetchSubsidiaryClaims] = serviceMethods.useFetch({
      callback: useCallback(async () => {
        if (!claimId) {
          return [];
        }
        return (await api.all(claimId)).subsidiary_claims;
      }, [claimId]),
      setLoading
    });
    return [subsidiaryClaims, setSubsidiaryClaims, fetchSubsidiaryClaims];
  },
  useUpdate: function () {
    let {
      setLoading,
      setSubsidiaryClaim
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const updateSubsidiaryClaim = serviceMethods.useUpdate({
      callback: useCallback(async subsidiary_claim => {
        const updatedSubsidiaryClaim = await api.update(subsidiary_claim.claim_id, subsidiary_claim.id, {
          subsidiary_claim
        });
        setSubsidiaryClaim && setSubsidiaryClaim(updatedSubsidiaryClaim);
        return updatedSubsidiaryClaim;
      }, [setSubsidiaryClaim]),
      setLoading
    });
    return updateSubsidiaryClaim;
  }
};
const useCrud = _ref3 => {
  let {
    claimId,
    setLoading
  } = _ref3;
  const [subsidiaryClaims, setSubsidiaryClaims, fetchSubsidiaryClaims] = subsidiaryClaimService.useFetchAll({
    claimId
  });
  const updateSubsidiaryClaimState = useCallback(updatedSubsidiaryClaim => {
    setSubsidiaryClaims(subsidiaryClaims => {
      const index = subsidiaryClaims.findIndex(sc => sc.id === updatedSubsidiaryClaim.id);
      subsidiaryClaims[index] = _objectSpread(_objectSpread({}, subsidiaryClaims[index]), updatedSubsidiaryClaim);
      return [...subsidiaryClaims];
    });
  }, [setSubsidiaryClaims]);
  const updateSubsidiaryClaim = subsidiaryClaimService.useUpdate({
    claimId,
    setSubsidiaryClaim: updateSubsidiaryClaimState
  });
  return {
    subsidiaryClaims,
    setSubsidiaryClaims,
    fetchSubsidiaryClaims,
    updateSubsidiaryClaimState,
    updateSubsidiaryClaim
  };
};
subsidiaryClaimService.useCrud = useCrud;
export default subsidiaryClaimService;